/*
* Text Input Component
* */
import React, { useEffect, useState, memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {randomIdentifier} from "../../../utils/helpers";

type Props = {
    label: String,
    isRequired: boolean,
    errorMsg: any,
    placeHolder: String,
    id: string,
    name: string,
    value: String,
    handleChange: Function,
    handleFocus: Function,
    handleBlur: Function,
    handleClick: Function,
    btnClass: String,
    btnLabel: String,
    btnHandleClick: Function,
    appendContent: any,
    disabled: boolean,
    readonly: boolean,
    rows: number,
    cols: number,
    maxlengthText: Number,
};


const TextareaComponent = ({
                                label,
                                isRequired,
                                errorMsg,
                                placeHolder,
                                id,
                                name,
                                value,
                                handleChange,
                                handleFocus,
                                handleBlur,
                                handleClick,
                                btnClass,
                                btnLabel,
                                btnHandleClick,
                                appendContent,
                                disabled,
                                readonly,
                                rows,
                                cols,
                                maxlengthText,
                            }: Props) => {

    const [text, setText] = useState(value);
    const textAreaRef = useRef(null);

    useEffect(() => {
        setText(value);
    }, [value])
    const _handleChange = (e) => {
        if(typeof handleChange == 'function') handleChange(e)
        setText(e.target.value)
    }

    const listenScrollEvent = (e) => {
        var scrollTop = textAreaRef.current.scrollTop;
        document.getElementById('backdrop').scrollTop = scrollTop
    }

    return (
        <div className="textarea-component">
            {
                label && <label className={(isRequired) ? "required": ""}>{label}</label>
            }
            <div className="input-group">
                <textarea
                        className={errorMsg.length == 0 ? "form-control": "form-control form-control-error"}
                        rows={rows}
                        placeholder={placeHolder}
                        id={id}
                        name={name}
                        onChange={_handleChange}
                        onBlur={handleBlur}
                        onClick={handleClick}
                        onFocus={handleFocus}
                        readOnly={readonly}
                        onScroll={listenScrollEvent}
                       disabled={disabled}
                       cols={cols}
                       maxLength={maxlengthText ?? 300}
                        value={text}
                        ref={textAreaRef}
                >{text}</textarea>
                {(btnLabel.length == 0) ? "" :
                    <button type="button" className={btnClass} onClick={btnHandleClick}>{btnLabel}</button>
                }
                {!appendContent ? "" : appendContent}
            </div>
            {errorMsg.length == 0 ? "" :
                <span className="input-error show">{errorMsg}</span>
            }
        </div>
    );
};

TextareaComponent.defaultProps = {
    isRequired: false,
    btnHandleClick: ()=>{},
    handleChange: ()=>{},
    handleFocus: ()=>{},
    handleBlur: ()=>{},
    handleClick: ()=>{},
    value: "",
    id: "js-"+ randomIdentifier(),
    name: "input-"+ randomIdentifier(),
    errorMsg: "",
    placeHolder: "",
    btnClass: "",
    btnLabel: "",
    appendContent: false,
    disabled: false,
    readonly: false,
    rows: 5,
    maxlengthText: 300
};

export default memo(TextareaComponent);
